import React, {useRef, useState} from "react";
import CustomTable, {
    CustomPagination,
    EnhancedTableHead,
    EnhancedTableToolbar, MuiPaper
} from "../../../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import * as snackbarActions from "../../../Redux/Actions/SnackbarActions/SnackbarActions"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import ReusableSalesHeader from "./ReusableSalesHeader";
import {useReusableDataFetch} from "../CustomHooks/useReusableDataFetch";
import axios from "axios";
import config from "../../../Helpers/config.json";
import {exportPDF} from "../../../Utils/exportPDF";
import {errorMessages} from "../../../Helpers/ErrorMessages";
import PharmacySnackbar from "../../../Utils/Snackbars/SnackbarUtil";
import Paper from "@material-ui/core/Paper";
import Form from "react-bootstrap/Form";
import {titleCase} from "../../../Utils/titleCaseFunction";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import {Link} from "react-router-dom";


const headData = [{id: 'date', numeric: false, disablePadding: false, label: 'Date'},
    {id: 'supplier', numeric: false, disablePadding: false, label: 'Supplier Name'},
    {id: 'transactionId', numeric: false, disablePadding: false, label: 'Transaction#'},
    {id: 'total', numeric: false, disablePadding: false, label: 'Total'},
    {id: 'balance', numeric: false, disablePadding: false, label: 'Balance'},
];

const AccountsPayables = ({actions, snackbars}) => {
    const csvRef = useRef();
    const [creditors, setCreditors] = useState([]);
    const {loading,  activePage, search,closeSnackbar,
        handleChangeActivePage, handleChangeSearch,  reusableProps
    } = useReusableDataFetch(actions, 'accounts_payables')
    const suppliers = [{id:12, name:'John Doe', invoice_no:100, date:'2021-10-20',amount:2000, balance:0}]


    const downloadPDF = () => {
        axios.get(`${config.epharmUrl}/accounting/getalldebtors`).then(response => {
            const res = response.data;
            const dt = res ? res : [];
            exportPDF("Creditors", [["Date", "Supplier", "Transaction#", "Total",'Balance']],
                dt.map((item) => [item.date, item.supplier_name, item.purchase_id,
                    item.amount, item.balance]), "Creditors.pdf");
        }).catch(error => {
            errorMessages(error, null, actions)
        });
    };

    const fetchInvoiceData = () => {
        axios.get(`${config.epharmUrl}/accounting/getalldebtors`).then(response => {
            const res = response.data;
            const dt = res ? res : [];
            setCreditors(dt)
            csvRef.current.link.click();
        }).catch(error => {
            errorMessages(error, null, actions)
        });
    }
    const {open, variant, message} = snackbars;
    const headers = [{label: 'Date', key: 'date'}, {label: 'Supplier Name', key: 'supplier_name'},
        {label: 'Transaction#', key: 'transaction_id'}, {label: 'Total', key: 'amount'},
        {label: 'Balance', key: 'balance'}]
    return (
        <ReusableSalesHeader headers={headers} fetchCsvData={fetchInvoiceData} csvData={creditors}
           csvRef={csvRef} csvTitle='Creditors' downLoadPdf={downloadPDF} {...reusableProps}>
            <PharmacySnackbar handleCloseBar={closeSnackbar} variant={variant} message={message} open={open}/>
            <div className="mui-tables">
                <MuiPaper>
                    <EnhancedTableToolbar title='Debtors'>
                        <Form.Control type="text" value={search ? titleCase(search) : ''} onChange={handleChangeSearch}
                                      className='form__control'
                                      placeholder="Search" style={{float: 'right'}}/>
                    </EnhancedTableToolbar>
                    <TableContainer>
                        <Table
                            aria-labelledby="tableTitle"
                            size='medium'
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead headCells={headData}/>
                            {loading ? <TableBody><TableRow>
                                <TableCell colSpan="5" align="center"><img src="/images/smsloader.gif"
                                                                           alt="loader"/></TableCell>
                            </TableRow></TableBody> : suppliers.length > 0 ?
                                <TableBody>
                                    {suppliers.slice(0, 10)
                                        .map((item, index) => {
                                            return (
                                                <TableRow
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={item.id}
                                                    className='mui-table-row'>
                                                    <TableCell>{item.date}</TableCell>
                                                    <TableCell>{item.name}</TableCell>
                                                    <TableCell>{item.invoice_no}</TableCell>
                                                    <TableCell>{item.amount}</TableCell>
                                                    <TableCell>{item.balance}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                                : <TableBody><TableRow>
                                    <TableCell colSpan="5" align="center">No records found</TableCell>
                                </TableRow></TableBody>}
                        </Table>
                    </TableContainer>
                    <CustomPagination data={suppliers} records={10} activePage={activePage} total_count={1}
                                      handleChangeNextPage={handleChangeActivePage}/>
                </MuiPaper>
            </div>
        </ReusableSalesHeader>
    )
};

function mapStateToProps(state) {
    return {snackbars: state.snackbars}
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountsPayables);
